import { createRoute, lazyRouteComponent } from "@tanstack/react-router";
import { z } from "zod";

import { authenticatedRoute } from "../_authenticated.js";

const projectsSearchSchema = z.object({
  view: z.enum(["table", "board"]).optional().catch(undefined),
});

export const projectsRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/projects",
  validateSearch: (search: Record<string, unknown>) => projectsSearchSchema.parse(search),
  component: lazyRouteComponent(() => import("./projects.page.js"), "ProjectsPage"),
});
